import { z } from "zod";

export const acceptActivityRequestSchema = z
  .object({
    isStand: z.boolean(),
    placeName: z.string(),
    mode: z.enum(["accept", "refuse"]).optional(),
  })
  .superRefine((val, ctx) => {
    // If mode is "refuse", placeName can be empty
    if (val.mode === "refuse") {
      return;
    }
    
    // If mode is "accept" or not provided, validate that either isStand is true OR placeName is filled
    const isValid = val.isStand || val.placeName.length > 0;
    if (!isValid) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Veuillez renseigner un lieu",
        path: ["placeName"],
      });
    }
  });

export const defaultAcceptActivityRequestValues = {
  isStand: false,
  placeName: "",
};

export type AcceptActivityRequestForm = z.infer<
  typeof acceptActivityRequestSchema
>;
